import SectionHeader from './sectionHeader';
import CheckedTips from '../common/checkedTips';
import { whyCleartax } from '../../constants';
import cx from 'classnames';

const WhyCleartax = ({ showTitle = true }) => (
  <div className="why-cleartax-block">
    {showTitle ? <SectionHeader title="Why ClearTax Invest?" /> : null}
    <div className={cx('content', !showTitle ? 'mt30' : null)}>
      <CheckedTips tips={whyCleartax} />
    </div>
    <style jsx>{`
      .content {
        padding: 0 0 15px;
      }
    `}</style>
  </div>
);

export default WhyCleartax;



// WEBPACK FOOTER //
// ./components/plan/whyCleartax.tsx